<template>
  <div class="home_block_1" id="home_block_1">
    <div class="hb1_left">
      <div class="hb1_left_top" :style="leftTopStyle">
      </div>
      <div class="hb1_left_bottom">
        <div class="hb1_left_bottom_t" :style="rightBottomBg1Style">
          <div class="title1">
            <img class="title-dragon" alt="标题" :src="titleDragonImg">
            <span @click="toWorkList('书法集')" style="cursor: pointer">双勾历代法帖</span>
            <img class="title-dragon" alt="标题" :src="titleDragonImg">
          </div>
          <div :class="{'title2 opacity1-anim':true,'active':ldsf.title2Active} ">
            <div class="title2-text">{{ ldsf.worksName }}</div>
          </div>
          <div class="statistics">
            <span class="key">序号</span>
            <div class="value value-order">
              <ei-num-list :num="ldsf.order"></ei-num-list>
            </div>
            <span class="key">字数</span>
            <div class="value value-count">
              <ei-num-list :num="ldsf.wordCount"></ei-num-list>
            </div>
            <span class="key">累计</span>
            <div class="value value-total">
              <ei-num-list :num="ldsf.wordTotal"></ei-num-list>
            </div>
          </div>
        </div>
        <div class="hb1_left_bottom_b" :style="rightBottomBg2Style">
          <div class="title1">
            <img class="title-cloud" alt="标题"  :src="splitCloudImg">
            <span  @click="toWorkList('绘画集')" style="cursor: pointer">鉴赏历代名画</span>
            <img class="title-cloud" alt="标题"  :src="splitCloudImg">
          </div>
          <div class="title2">
            <span>三端妙用笔</span>
            <span>六艺重银钩</span>
            <span>上下五千年</span>
            <span>翰墨有丰碑</span>
          </div>
          <div class="categories">
            <div>
              <a>双勾</a>
              <img class="split-cloud" alt="分隔符"  :src="splitCloudImg"/>
              <a>拓本</a>
              <img class="split-cloud" alt="分隔符"  :src="splitCloudImg"/>
              <a>墨本</a>
              <img class="split-cloud" alt="分隔符"  :src="splitCloudImg"/>
              <a>彩本</a>
            </div>
            <div>
              <span>矢量图</span>
              <img class="split-cloud" :src="splitCloudImg" alt="分隔符"/>
              <span>电子书</span>
              <img class="split-cloud" :src="splitCloudImg" alt="分隔符"/>
              <span>影像志</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hb1_right">
      <div class="hb1_right_top">
        <div class="hb1_right_top_l">
          <div :class="{'title opacity1-anim':true,'active':currentPoem.currentPoemTitleActive}" style="color: #fff;">
            <img  :src="characterPattern" class="character-pattern" style="vertical-align: middle">
            <div class="article-category"><span @click="toWorkDetail('3f1ff63e-25d1-4ace-8d59-0c25f70fd139')" style="cursor: pointer">{{ currentPoem.name}}</span></div>
            <img  :src="characterPattern" class="character-pattern"
                 style="vertical-align: middle;transform: scaleX(-1);">
          </div>
          <div class="more">
            <a>
              <img :src="serialNumberPattern3">
            </a>
          </div>
          <div class="article">
            <ul style="color: #fff" class="article-list">
              <li v-for="(item,index) in currentPoem.sentenceList" :key="index"
                  :class="{'article-item opacity0-anim':true,'active':item.opacity0AnimActive,'hidden':item.hidden}">
                <a>
                  <img  :src="serialNumberPattern1" class="serial-number-pattern"
                       style="vertical-align: middle"/>
                  <div class="article-title"><span
                    :class="{'fontWeight-anim':true,'active':item.activeFontWeight}">{{ item.sentence }}</span>
                  </div>
                  <div :class="{'article-fen fontColor-anim':true,'active':item.activeFontWeight}">
                    <span class="fenZi">{{ index + 1 }}</span><span
                    class="fenMu">{{ currentPoem.sentenceList.length }}</span>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="hb1_right_top_r" :style="rightTopStyle"></div>
      </div>
      <div class="hb1_right_bottom" :style="rightBottomStyle">
<!--        @mouseover="ldsf.hoverActive=true" @mouseout="ldsf.hoverActive=false"-->
        <div :class="{'renwu_img opacity1-anim':true,'active':ldsf.title2Active}">
          <img :src="ldsf.renwuUrl"/>
        </div>
<!--        <div class="yingzhang_desc">
          <span>当代 • 凌烟阁 • 双勾</span>
          <br>
          <span>原创佳作 • 独家版权</span>
        </div>-->
        <div :class="{'works_desc_picture opacity1-anim':true,'active':ldsf.title2Active}">
          <img  :src="ldsf.descPictureUrl"/>
        </div>
        <a @click="toWorksDetail(ldsf.rowGuid)">
          <div :class="{'works_title_top opacity1-anim':true,'active':ldsf.title2Active}">
            <ei-word :words="ldsf.topText?ldsf.topText:''" :active="ldsf.hoverActive"></ei-word>
          </div>
          <div :class="{'works_title_midden opacity1-anim':true,'active':ldsf.title2Active}">
<!--            <span>{{ldsf.description}}</span>-->
            <ei-word :words="ldsf.description?ldsf.description:''" :active="ldsf.hoverActive"></ei-word>
          </div>
          <div :class="{'works_title_middendown opacity1-anim':true,'active':ldsf.title2Active}">
<!--            <span>{{ldsf.descriptiondown}}</span>-->
            <ei-word :words="ldsf.descriptiondown?ldsf.descriptiondown:''" :active="ldsf.hoverActive"></ei-word>
          </div>
          <div :class="{'works_title_bottom opacity1-anim':true,'active':ldsf.title2Active}">
            <ei-word :words="ldsf.bottomText?ldsf.bottomText:''" :active="ldsf.hoverActive"></ei-word>
          </div>
<!--          <div :class="{'works_people opacity1-anim':true,'active':ldsf.title2Active}">
&lt;!&ndash;            <ei-word
              :words="ldsf.dynasty+'•'+ldsf.author"
              :active="ldsf.hoverActive"></ei-word>&ndash;&gt;
          </div>-->
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import {
  queryHomeBlockInHomeAction,
  queryPoemListInHomeAction,
  queryWorksListInHomeAction,
} from '@/api/reception/home-api'
import {isFailure} from '@/eiuov-utils/axios/response'
import Vue from 'vue'
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)
export default {
  name: 'EiHomeBlock1',
  props: {
    homeCarousel1smallList:{
      type:Array,
      required: true
    },
  },
  data() {
    return {
      home1smallImg:[],
      leftTopStyle: {},
      rightTopStyle: {},
      rightBottomStyle: {},
      rightBottomBg1Style:{},
      rightBottomBg2Style:{},
      titleDragonImg: '/upload/homeBlock/1/titleDragonImg.png',
      titleCloudImg: '/upload/homeBlock/1/titleCloudImg.png',
      titleButterflyImg: '/upload/homeBlock/1/titleButterflyImg.png',
      moreImg: '/upload/homeBlock/1/moreImg.png',
      splitCloudImg: '/upload/homeBlock/1/splitCloudImg.png',
      articleListImg: '/upload/homeBlock/1/articleListImg.png',
      characterPattern:require("../eiuov-ui/_ei-flower/1.png"),
      serialNumberPattern1:require("../eiuov-ui/_ei-flower/作品序列号花纹1.png"),
      serialNumberPattern3:require("../eiuov-ui/_ei-flower/作品序列号花纹3.png"),
      smallIndex:0,
      //历代书法
      ldsf: {
        rowGuid: '',
        author: '',
        dynasty: '',
        worksName: '',
        order: '000',
        wordCount: '0000',
        wordTotal: '00000',
        descPictureUrl: '',
        list: [],
        index: 0,
        title2Active: true,
        hoverActive: false,
        renwuUrl: '',
        topText:'',
        bottomText:'',
        descriptiondown:'',
      },
      renwuList: [
        {
          url: '/upload/homeBlock/1/renwu1.png',
        },
        {
          url: '/upload/homeBlock/1/renwu2.png',
        },
        {
          url: '/upload/homeBlock/1/renwu3.png',
        }
      ],
      //文章专栏
      currentPoem: {
        list: [],
        index: 0,
        title: '',
        sentenceList: [],
        activeSentence: 0,
        currentPoemTitleActive: true
      },
      //
      homeBlockList: [],
      worksList: [],
      poemList: []
    }
  },
  created() {
    queryHomeBlockInHomeAction({blockName: '首页模块1'}).then((res) => {
      if (isFailure(res)) return
      this.homeBlockList = res.data.list
      this.initHomeBlockList(this.homeBlockList)
    })
    queryWorksListInHomeAction({type:"首页模块1统计"}).then((res) => {
      if (isFailure(res)) return
      this.worksList = res.data.list
      this.initWorksList(this.worksList)
    })
    queryPoemListInHomeAction({}).then((res) => {
      if (isFailure(res)) return
      this.poemList = res.data.list
      this.initPoemList(this.poemList)
    })
  },
  methods: {
    toWorkDetail(id){
      this.$router.push({
        path: '/WorksDetail',
        query: { guid: id },
      })
    },
    toWorkList (type) {
      this.$router.push({
        path: '/WorksList',
        query: { type: type }
      })
    },
    initHomeBlockList(list) {
      if (list.length === 0) return
      this.leftTopStyle = this.getBackGroundImage(list, '左上')
      this.rightTopStyle = this.getBackGroundImage(list, '右上')
      this.rightBottomStyle = this.getBackGroundImage(list, '右下')
      this.rightBottomBg1Style = this.getBackGroundImage(list, '左下文字背景1')
      this.rightBottomBg2Style = this.getBackGroundImage(list, '左下文字背景2')
    },
    initWorksList(list) {
      if (list.length === 0) return
      this.ldsf.list = list
      this.setLDSF()
      setInterval(() => {
        this.ldsf.title2Active = false
        this.ldsf.hoverActive=true
        setTimeout(() => {
         /* this.ldsf.hoverActive=false*/
          this.setLDSF()
          setTimeout(() => {
            this.ldsf.title2Active = true
          }, 500)
          setTimeout(() => {
            this.ldsf.hoverActive=false
          }, 4500)
        }, 500)
      }, 10000)
    },
    initPoemList(list) {
      if (list.length === 0) return
      this.currentPoem.list = list
      this.setCurrentPoem()
    },
    getBackGroundImage(list, name) {
      if (list.length === 0) return {}
      for (let i = 0; i < list.length; i++) {
        if (list[i].blockName === name && list[i].picture !== null) {
          return {
            backgroundImage: 'url(' + list[i].picture.url + ')'
          }
        }
      }
      return {}
    },
    setLDSF() {
      if (this.ldsf.index >= this.ldsf.list.length) {
        this.ldsf.index = 0
      }
      this.$set(this.ldsf, 'rowGuid', this.homeCarousel1smallList[this.smallIndex].link)
      this.$set(this.ldsf, 'dynasty', this.ldsf.list[this.ldsf.index].dynasty)
      this.$set(this.ldsf, 'author', this.ldsf.list[this.ldsf.index].author)
      this.$set(this.ldsf, 'worksName', this.ldsf.list[this.ldsf.index].worksName)
      this.$set(this.ldsf, 'order', this.ldsf.list[this.ldsf.index].order)
      this.$set(this.ldsf, 'wordCount', this.ldsf.list[this.ldsf.index].wordCount)
      this.$set(this.ldsf, 'wordTotal', this.ldsf.list[this.ldsf.index].wordTotal)
      this.$set(this.ldsf, 'descPictureUrl', this.ldsf.list[this.ldsf.index].descPictureUrl)
      this.$set(this.ldsf, 'renwuUrl', this.homeCarousel1smallList[this.smallIndex].url)
      this.$set(this.ldsf, 'topText',this.homeCarousel1smallList[this.smallIndex].topText?this.homeCarousel1smallList[this.smallIndex].topText:'')
      let str =this.homeCarousel1smallList[this.smallIndex].description
      if (str!==undefined || str!==""){
        this.$set(this.ldsf, 'description',str.substring(0,str.lastIndexOf('+')))
      }else {
        this.$set(this.ldsf, 'description','')
      }
      this.$set(this.ldsf, 'descriptiondown',str.substring(str.lastIndexOf('+')+1))
      this.$set(this.ldsf, 'bottomText',this.homeCarousel1smallList[this.smallIndex].bottomText?this.homeCarousel1smallList[this.smallIndex].bottomText:'')
      if (this.smallIndex>=this.homeCarousel1smallList.length-1){
        this.smallIndex=0
      }else {
        this.smallIndex++
      }
      this.ldsf.index++
    },
    setCurrentPoem() {
      this.$set(this.currentPoem, 'name', this.currentPoem.list[this.currentPoem.index].name)
      this.$set(this.currentPoem, 'sentenceList', this.currentPoem.list[this.currentPoem.index].sentenceList)
      this.currentPoem.index++
      this.setActiveSentence()
      setInterval(() => {
        this.setActiveSentence()
      }, 3000)
    },
    setActiveSentence() {
      let activeSentence = this.currentPoem.activeSentence
      let index = this.currentPoem.index
      if (activeSentence === this.currentPoem.sentenceList.length) {
        this.currentPoem.activeSentence = 0
        activeSentence = 0
        // 页大小与 .article 的 8 行可见窗口保持一致
        let quYu = this.currentPoem.sentenceList.length % 8
        let quZheng = parseInt(this.currentPoem.sentenceList.length / 8)
        if (quYu > 0) {
          for (let i = 0; i < quYu; i++) {
            this.$set(this.currentPoem.sentenceList[quZheng * 8 + i], 'opacity0AnimActive', true)
          }
        }
        this.currentPoem.currentPoemTitleActive = false
        setTimeout(() => {
          this.currentPoem.currentPoemTitleActive = true
          if (index === this.currentPoem.list.length) {
            this.currentPoem.index = 0
            index = 0
          }
          let lastIndex = index - 1 >= 0 ? index - 1 : this.currentPoem.list.length - 1
          this.currentPoem.list[lastIndex].sentenceList.forEach((item) => {
            item.activeFontWeight = false
            item.opacity0AnimActive = false
            item.hidden = false
          })
          this.$set(this.currentPoem, 'name', this.currentPoem.list[index].name)
          this.$set(this.currentPoem, 'sentenceList', this.currentPoem.list[index].sentenceList)
          this.$set(this.currentPoem.sentenceList[activeSentence], 'activeFontWeight', true)
          this.currentPoem.index++
          this.currentPoem.activeSentence++
        }, 1000)
        return
      }
      if (activeSentence === 0) {
        this.$set(this.currentPoem.sentenceList[activeSentence], 'activeFontWeight', true)
      } else {
        this.$set(this.currentPoem.sentenceList[activeSentence - 1], 'activeFontWeight', false)
        this.$set(this.currentPoem.sentenceList[activeSentence], 'activeFontWeight', true)
      }
      // 播放完 8 行后整页上翻
      if (activeSentence !== 0 && activeSentence % 8 === 0) {
        let quZheng = parseInt(activeSentence / 8)
        let hiddenLine = (quZheng - 1) * 8
        this.$set(this.currentPoem.sentenceList[hiddenLine], 'opacity0AnimActive', true)
        this.$set(this.currentPoem.sentenceList[hiddenLine + 1], 'opacity0AnimActive', true)
        this.$set(this.currentPoem.sentenceList[hiddenLine + 2], 'opacity0AnimActive', true)
        this.$set(this.currentPoem.sentenceList[hiddenLine + 3], 'opacity0AnimActive', true)
        this.$set(this.currentPoem.sentenceList[hiddenLine + 4], 'opacity0AnimActive', true)
        this.$set(this.currentPoem.sentenceList[hiddenLine + 5], 'opacity0AnimActive', true)
        this.$set(this.currentPoem.sentenceList[hiddenLine + 6], 'opacity0AnimActive', true)
        this.$set(this.currentPoem.sentenceList[hiddenLine + 7], 'opacity0AnimActive', true)
        setTimeout(() => {
          this.$set(this.currentPoem.sentenceList[hiddenLine], 'hidden', true)
          this.$set(this.currentPoem.sentenceList[hiddenLine + 1], 'hidden', true)
          this.$set(this.currentPoem.sentenceList[hiddenLine + 2], 'hidden', true)
          this.$set(this.currentPoem.sentenceList[hiddenLine + 3], 'hidden', true)
          this.$set(this.currentPoem.sentenceList[hiddenLine + 4], 'hidden', true)
          this.$set(this.currentPoem.sentenceList[hiddenLine + 5], 'hidden', true)
          this.$set(this.currentPoem.sentenceList[hiddenLine + 6], 'hidden', true)
          this.$set(this.currentPoem.sentenceList[hiddenLine + 7], 'hidden', true)
        }, 1000)
      }
      this.currentPoem.activeSentence++
    },
    toWorksDetail(worksGuid) {
      this.$router.push({
        path: '/WorksDetail',
        query: {guid: worksGuid},
      })},
  }
}


</script>

<style scoped lang="scss">
@use "sass:math";
$hb1_width: 1600px;
$hb1_height: 820px;
$hb1_left_width: 640px;
$hb1_in_margin: 30px;
.home_block_1 {
  margin: 125px auto;
  width: $hb1_width;
  height: $hb1_height;
  display: flex;
  justify-content: space-between;

  // 标题/分隔符图片尺寸（px 由 postcss 自动转 vw）
  .title-dragon {
    width: 120px;
  }

  .title-cloud {
    width: 110px;
  }

  .split-cloud {
    width: 50px;
  }

  .character-pattern {
    width: 50px;
  }

  .serial-number-pattern {
    width: 22.5px;
  }

  .hb1_left {
    width: $hb1_left_width;
    height: 100%;
    overflow: hidden;

    .hb1_left_top {
      width: 100%;
      height: 270px;
      margin-bottom: $hb1_in_margin;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center;
      transition: background-size 0.5s linear;
      background-color: #B94044;

      &:hover {
        background-size: 120% 120%;
        transition: background-size 0.5s linear;
      }

    }

    .hb1_left_bottom {
      width: 100%;
      height: 520px;
      color: #fff;
      display: flex;
      flex-direction: column;

      .hb1_left_bottom_t {
        width: 100%;
        // 50% 改为弹性等分：内容超出时自动增高，不再被下一块的不透明底色压盖
        flex: 1 1 0;
        background-color: rgb(46, 76, 102);

        .title1 {
          display: flex;
          flex-flow: row;
          padding-top: 24px;
          padding-bottom: 10px;
          justify-content: center;
          align-items: center;
          font-size: 36px;
          line-height: 40px;

          img:first-child {
            vertical-align: middle;
            margin-right: 10px;
          }

          img:last-child {
            vertical-align: middle;
            -moz-transform: scaleX(-1);
            -webkit-transform: scaleX(-1);
            -o-transform: scaleX(-1);
            transform: scaleX(-1);
            margin-left: 10px;
          }

          span {
            margin-left: 10px;
            margin-right: 10px;
          }

        }

        .title2 {
          display: flex;
          flex-flow: column;
          padding-bottom: 25px;
          align-items: center;
          font-size: 28px;
          line-height: 40px;

          .title2-text {
            margin-top: 22px;
          }
        }


        .statistics {
          margin-top: 20px;
          width: 100%;
          display: flex;
          justify-content: center;

          .key:not(first-child) {
            margin-left: 10px;
          }

          .key {
            margin-top: -10px;
            writing-mode: vertical-lr;
            text-align: center;
            letter-spacing: 10px;
            font-size: 22px;
          }

          .value {
            font-family: Impact, Arial, serif;
            margin-bottom: 5px;
            color: inherit;
            font-size: 38px;
            margin-left: 5px;
            margin-right: 5px;
          }

          .value-order {
            width: 75px;
            margin-left: 10px;
            margin-right: 20px;
            text-align: center;
          }

          .value-count {
            width: 100px;
            margin-left: 10px;
            margin-right: 20px;
            text-align: center;
          }

          .value-total {
            width: 125px;
            margin-left: 10px;
            text-align: center;
          }

        }

      }

      .hb1_left_bottom_b {
        width: 100%;
        flex: 1 1 0;
        background-color: rgb(36, 58, 79);

        .title1 {
          display: flex;
          padding-top: 26px;
          padding-bottom: 14px;
          justify-content: center;
          align-items: center;
          // 原 2em 为固定字号，不随 postcss 的 px->vw 缩放，小屏时会把面板撑爆
          font-size: 32px;
          line-height: 40px;


          img:first-child {
            vertical-align: middle;
          }

          img:last-child {
            vertical-align: middle;
            -moz-transform: scaleX(-1);
            -webkit-transform: scaleX(-1);
            -o-transform: scaleX(-1);
            transform: scaleX(-1);
          }

          span {
            margin-left: 10px;
            margin-right: 10px;
          }

        }

        .title2 {
          display: flex;
          justify-content: center;
          padding-bottom: 24px;

          span {
            // 显式写 px 才会被转成 vw，跟随整页等比缩放
            font-size: 18px;
            line-height: 28px;
          }

          span:not(first-child) {
            margin-left: 10px;
          }

        }

        .categories {
          display: flex;
          flex-flow: column;
          align-items: center;
          // 原 1.5em 同样不随 vw 缩放
          font-size: 24px;
          line-height: 44px;

          img {
            margin-left: 5px;
            margin-right: 5px;
          }

        }
      }
    }
  }

  .hb1_right {
    width: $hb1_width - $hb1_left_width - 30;
    height: 100%;
    overflow: hidden;

    .hb1_right_top {
      width: 100%;
      height: 380px;
      background-color: rgb(122, 34, 32);
      margin-bottom: $hb1_in_margin;
      display: flex;

      .hb1_right_top_l {
        width: 60%;
        position: relative;
        // 纵向 flex：标题按内容高度，列表吃掉剩余空间，整体不会超出 380px 被裁掉
        display: flex;
        flex-direction: column;

        .title {
          flex: 0 0 auto;
          width: 90%;
          margin: 20px auto 0;
        }
      }


      .hb1_right_top_r {
        width: 40%;
        background-size: 100% 100%;
        background-position: center;
        transition: background-size 0.5s linear;
        background-color: #C78100;

        &:hover {
          background-size: 120% 120%;
        }
      }

    }

    .hb1_right_bottom {
      width: 100%;
      height: 410px;
      position: relative;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-color: #EDEDED;
    }

    .works_desc_picture {
      margin: 0 auto;
      width: 50%;
      height: 90%;
      background-position: center;
      background-repeat: no-repeat;
      background-position-y: 10px;
      text-align: center;
    }

    .works_people .title-bulb {
      position: absolute;
      top: 130px;
      right: 130px;
      writing-mode: vertical-lr;
      letter-spacing: 5px;
      font-size: 25px;
      height: 250px;
      text-align: center;
    }
    .works_title_top .title-bulb {
      position: absolute;
      left: 0px;
      top: 0px;
      width: 100%;
      letter-spacing: 5px;
      white-space: pre-wrap;
      font-size: 25px;
      height: 400px;
      color: #2358d4;
    }

    .works_title_midden .title-bulb {
      position: absolute;
      top: 175px;
      letter-spacing: 5px;
      font-size: 40px;
      white-space: pre-wrap;
      height: 250px;
      width: 100%;
      color: #e50205;
    }
    .works_title_middendown .title-bulb {
      position: absolute;
      top: 185px;
      left: 200px;
      letter-spacing: 5px;
      font-size: 30px;
      white-space: pre-wrap;
      height: 250px;
      width: 100%;
      color: #e50205;
    }

    .works_title_bottom .title-bulb {
      position: absolute;
      top: 250px;
      left: 0px;
      letter-spacing: 5px;
      white-space: pre-wrap;
      font-size: 28px;
      width: 100%;
      height: 250px;
      color: #2358d4;
  }

    .renwu_img {
      width: 100%;
      height: 100%;
      position: absolute;

    }

    .yingzhang_desc {
      width: 170px;
      height: 50px;
      position: absolute;
      right: 83px;
      top: 86px;
      text-align: center;
      line-height: 26px;
      font-size: 18px;
      font-weight: bold
    }

  }

  .more {
    float: right;
    position: absolute;
    right: 70px;
    top: 10px;
    color: #fff;

    span {
      writing-mode: vertical-lr;
      margin-top: 6px;
      letter-spacing: 3px
    }

    img {
      position: absolute;
      width: 40px;
      left: -11px
    }

    a:hover img {
      transition: all 0.5s linear;
      transform: rotate(-180deg);
    }

  }


}

.title-dot {
  display: inline-block;
  margin: 0 10px;
  width: 9px;
  height: 10px;
  vertical-align: middle;
  background: url(./image/title_dot.png) center no-repeat;
  overflow: hidden;
  text-align: center;
}

.article-category {
  display: inline-block;
  margin-left: 15px;
  margin-right: 15px;
  height: 25px;
  font-size: 25px;
  line-height: 25px;
  vertical-align: middle
}

.article {
  width: 95%;
  // 右内边距 4px：overflow 是按 padding box 裁剪的，行尾序号的右边缘等于内容盒右边缘，
  // 加 4px 后裁剪线外移，序号离裁剪线留出余量
  padding-right: 4px;
  // 可见窗口固定为 8 行：行距 39px（行高 27px + 下边距 12px）× 8 = 312px
  // max-height 精确等于 8 行高度，避免第 9 行被裁出半行
  flex: 1 1 auto;
  min-height: 0;
  max-height: 312px;
  overflow: hidden;
  position: relative;
  margin-top: 10px;

  .article-list {
    // 清掉浏览器给 ul 的默认上下 margin；显式 px 字号让行盒 strut 也参与 vw 等比缩放
    padding-left: 0;
    margin: 0 0 0 30px;
    font-size: 16px;
  }

  .article-item {
    // 行距 27px + 12px = 39px，8 行正好 312px，与 .article 的窗口高度一致
    margin-bottom: 12px;

    .article_num {
      display: inline-block;
      width: 20px;
      height: 27px;
      text-align: right;
      vertical-align: middle;
      line-height: 27px;
      font-style: italic;
      font-size: 18px;
    }

    .article-title {
      margin-left: 15px;
      height: 27px;;
      display: inline-block;
      vertical-align: middle;
      line-height: 27px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 20px;
    }

    .article-fen {
      // 原来是定宽 width:60px，装不下 "10/18" 这类 4 位数，末位会被 .article 的 overflow 裁掉；
      // 改成 min-width：短序号保持原位置不变，长序号按内容自动撑开
      min-width: 60px;
      float: right;
      font-size: 17px;
      height: 26px;
      font-style: italic;
      white-space: nowrap;

      .fenZi {
        font-size: 22px;
        margin-right: 5px;

      }

      .fenMu:before {
        content: "/";
        margin-right: 5px;
      }
    }

  }
}

* img, span, a, div {
  user-select: none;
  -webkit-user-drag: none;
}
</style>
